<template>
  <div class="home">
    <Navbar />
    <v-content>
      <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-flex xs12 md6 lg3>
            <v-card height="100%" @click.native="$router.push('/exercises')">
              <v-card-title primary-title>
                <h3>Exercises</h3>
              </v-card-title>
              <v-card-text>
                Create and edit exercises, their roleplayers and teams.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md6 lg3>
            <v-card height="100%" @click.native="$router.push('/medical_cases')">
              <v-card-title primary-title>
                <h3>Medical Cases</h3>
              </v-card-title>
              <v-card-text>
                Create and edit medical cases used for all exercises.
              </v-card-text>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Navbar from '@/components/Navbar.vue'

  export default {
    name: 'home',
    components: {
      Navbar
    }
  }
</script>